import { PropsWithChildren } from "react";
import styles from "./WeddingAbc.module.css";

export default function WeddingAbc(props: PropsWithChildren) {
    return <ul className={styles.weddingAbc}>
        {props.children}
    </ul>
}
